export function isLoading(currentLoad) {
  return {
    type: "SET_LOADING",
    payload: currentLoad,
  };
}
